import React, { Component } from 'react';
import './Toggle.css';
class Toggle extends Component {
    constructor(props) {
        super(props);
        this._onChanged = this._onChanged.bind(this);
    }
    _onChanged(event) {
        this.props.onChange(event, this.props.value);
    }
    render() {
        return (
            <label className={this.props.className ? `toggle ${this.props.className}` : "toggle"}>
                <input type="checkbox" value={this.props.value} checked={this.props.checked} disabled={this.props.disabled} onChange={this._onChanged} />
                <div className="check" />
                <span>{this.props.children}</span>
            </label>
        );
    }
}
export default Toggle;


// WEBPACK FOOTER //
// ./src/Toggle.js